import React from "react";
import { FILTERS } from "../constants/filters";
import { chip, chipActive, panelHeading } from "../styles/ui";
import { useMediaQuery } from "../hooks/useMediaQuery";

// Thanh chọn hiệu ứng. Dùng <button> thật để bấm được bằng bàn phím.
//
// Trên điện thoại cả 8 hiệu ứng dồn thành một dải cuộn ngang cho đỡ tốn chiều
// cao; trên màn rộng thì rải xuống nhiều hàng như cũ.
export default function FilterBar({ value, onChange, style }) {
    const isMobile = useMediaQuery("(max-width: 640px)");

    return (
        <div style={{ ...wrap, ...style }}>
            <div style={panelHeading}>✨ Hiệu ứng</div>
            <div style={isMobile ? { ...strip, ...stripScroll } : strip}>
                {FILTERS.map(f => {
                    const active = f.id === value;
                    return (
                        <button
                            key={f.id}
                            type="button"
                            aria-pressed={active}
                            onClick={() => onChange(f.id)}
                            style={{
                                ...(active ? { ...chip, ...chipActive } : chip),
                                scrollSnapAlign: isMobile ? "start" : undefined
                            }}
                        >
                            {f.label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

const wrap = {
    marginTop: 16,
    width: "100%"
};

const strip = {
    display: "flex",
    flexWrap: "wrap",
    gap: 8
};

const stripScroll = {
    flexWrap: "nowrap",
    overflowX: "auto",
    scrollSnapType: "x proximity",
    paddingBottom: 6,
    WebkitOverflowScrolling: "touch",
    // Giữ overscroll trong phạm vi thanh này: cuộn hết dải hiệu ứng thì dừng,
    // không lan sang làm cả trang nảy/rung.
    overscrollBehaviorX: "contain"
};
